import {
	IsPricePointSetFromCookieActionTypes,
	RESET_IS_PRICEPOINT_SET_FROM_COOKIE,
	SET_IS_PRICEPOINT_SET_FROM_COOKIE,
} from '../actions/isPricePointSetFromCookieActionTypes';

export const initialState = false;

const isPricePointSetFromCookie = (
	state: boolean = initialState,
	action: IsPricePointSetFromCookieActionTypes
): boolean => {
	switch (action.type) {
		case SET_IS_PRICEPOINT_SET_FROM_COOKIE:
			return action.payload;
		case RESET_IS_PRICEPOINT_SET_FROM_COOKIE:
			return initialState;
		default:
			return state;
	}
};

export default isPricePointSetFromCookie;
